import { render, staticRenderFns } from "./mySeat.vue?vue&type=template&id=571c6a58"
import script from "./mySeat.vue?vue&type=script&lang=js"
export * from "./mySeat.vue?vue&type=script&lang=js"
import style0 from "./mySeat.vue?vue&type=style&index=0&id=571c6a58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports